import r2wc from '@r2wc/react-to-web-component';
import NetworkMap from "../components/NetworkMap";


const EmNetworkMap = r2wc(NetworkMap, {
  props: {
    geojson: 'string',
    networkMap: 'string',
    pin: 'string',
    pinSelected: 'string',
    iconSearch: 'string',
    noSearchSubheading: 'string',
    noSearchHeading: 'string',
    noSearchDesc: 'string',
    featureType: 'string'
  },
});

customElements.define("em-network-map", EmNetworkMap);
